import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) {}

  login(userName: string, password: string) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
    const searchParams = new URLSearchParams();
    searchParams.set('UserName', userName);
    searchParams.set('Password', password);
    searchParams.set('Grant_Type', 'password');
    return this.httpClient.post<object>(environment.apiPath + 'login', searchParams.toString(), {headers: headers});
  }

  checkToken() {
    if (sessionStorage.getItem('Token') == null || new Date(sessionStorage.getItem('ExpireDate')) < new Date()) {
      const tempWnSpecial = sessionStorage.getItem('WheelnewsSpecial');
      sessionStorage.clear();
      if (tempWnSpecial != null) {
        this.router.navigate(['/' + tempWnSpecial + 'login']).then(
          r => Swal.fire('Session  expired', 'You were absent for too long. Your session has ended.', 'error'));
      } else {
        this.router.navigate(['/login']).then(
          r => Swal.fire('Session  expired', 'You were absent for too long. Your session has ended.', 'error'));
      }
    }
  }

  checkLoginToken() {
    if (sessionStorage.getItem('Token') != null && new Date(sessionStorage.getItem('ExpireDate')) > new Date()) {
      this.router.navigate(['/home']).then(r => r);
    }
  }
}
